import { all, takeLatest } from 'redux-saga/effects';

import { fetchEmployees } from 'actions/employees';
import { fetchEmployeesSaga } from './fetchEmployees';

export default function* employeesSaga() {
  yield all([takeLatest(fetchEmployees, fetchEmployeesSaga)]);
}
